import { render } from "./BePartnerHotelsForm.vue?vue&type=template&id=69812be4&scoped=true"
import script from "./BePartnerHotelsForm.vue?vue&type=script&lang=js"
export * from "./BePartnerHotelsForm.vue?vue&type=script&lang=js"

import "./BePartnerHotelsForm.vue?vue&type=style&index=0&id=69812be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69812be4"]])

export default __exports__